import { useEffect, useRef } from 'react';
import Paper from '@mui/material/Paper';

const ErrorLinks = (props) => {
    const {formErrors, hideError, dark} = props;

    const linkRef = useRef(null);

    useEffect(() => {
        if (linkRef.current) linkRef.current.focus();
    }, [hideError, formErrors]);

    if (hideError || !formErrors || !Object.keys(formErrors).length) return null;

    return <Paper className={"error-box" + (dark ? " dark" : "")} role="alert">
        <div className={"error-title"}>{Object.keys(formErrors).length + " error" + (Object.keys(formErrors).length > 1 ? 's' : '') +
        " prohibited the processing of your request"}</div>
        <p>{"Please fix the following error" + (Object.keys(formErrors).length > 1 ? 's' : '') + ":"}</p>
        <ul>
            {Object.keys(formErrors).map((key, index) => (
                <li key={index}>
                    <a href={'#' + key} ref={index === 0 ? linkRef : null}>{formErrors[key]}</a>
                </li>
            ))}
        </ul>
    </Paper>;
};

export default ErrorLinks;